import noop from 'lodash/noop';
import { Injectable } from '@angular/core';
import { ConfirmPrompt } from '../services/confirm-prompt';

@Injectable()
export class LogSuggestionUnsavedGuard {
  constructor(private confirmPrompt: ConfirmPrompt) {}

  public canDeactivate(target, currentRoute, currentState, nextState) {
    const isMovingOut = !nextState.url.includes('/edit');
    if (isMovingOut && target.isDirty() && !target.isSaving && !target.isCanceling && !target.discardUnsavedChanges) {
      const msg = $localize`You have not saved the log. Discard changes?`;
      return this.confirmPrompt
        .show(msg, {
          title: $localize`Unsaved Changes`,
          approveButtonText: $localize`Yes`,
          cancelButtonText: $localize`No`,
        })
        .then(() => true, noop)
      ;
    }
    return true;
  }
}
